/**
 * Resumo da home de mic usa somente a central.
 * Mics individuais do mesmo galpão não entram nessa busca.
 */
export function pickSmartMicSensor(sensors) {
  const list = Array.isArray(sensors) ? sensors : []
  return list.find((sensor) => sensor?.type === 'smartmic_central_V3') || null
}

export function smartMicSensorKey(sensors) {
  return (Array.isArray(sensors) ? sensors : [])
    .map((sensor) => `${sensor?.pk ?? sensor?.id ?? ''}:${sensor?.type ?? ''}`)
    .join(',')
}
